var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Kushki } from "@kushki/js";
import { get } from "lodash";
var createContext = React.createContext, useContext = React.useContext;
var KushkiJsContext = createContext(undefined);
export var KushkiJsProvider = function (_a) {
    var children = _a.children, merchantId = _a.merchantId, inTestEnvironment = _a.inTestEnvironment, kushkiInfo = _a.kushkiInfo;
    var kushkiJs = new Kushki({
        inTestEnvironment: inTestEnvironment,
        merchantId: merchantId,
        kushkiInfo: kushkiInfo,
    });
    var request3DS = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestValidate3DS(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestCardToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestDeferred = function (bin) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestDeferred(bin, function (response) {
                if ("code" in response || "message" in response) {
                    return reject(response);
                }
                resolve(response);
            });
        });
    };
    var requestCashToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestCashToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestTransferToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestTransferToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestBankList = function () {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestBankList(function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestTransferSubscriptionBankList = function () {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestTransferSubscriptionBankList(function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestTransferSubscriptionToken = function (request) {
        return new Promise(function (resolve, reject) {
            return kushkiJs.requestTransferSubscriptionToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestCardSubscriptionToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestSubscriptionToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestCardAsyncToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestCardAsyncToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestBin = function (bin) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestBinInfo(bin, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestBrandsLogos = function () {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestBrandsLogosByMerchant(function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestSecureServiceValidation = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestSecureServiceValidation(request, function (response) {
                var code = get(response, "code");
                var message = get(response, "message");
                var validOtp = message === "ok" || code === "OTP000";
                var valid3DS = (message === "3DS000" && code === "ok") ||
                    (code === "3DS000" && message === "ok");
                if (validOtp || valid3DS)
                    return resolve(response);
                reject(response);
            });
        });
    };
    var requestSavedPaymentMethods = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestSavedPaymentMethods(request, function (response) {
                if ("code" in response ||
                    "message" in response ||
                    !Array.isArray(response))
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestValidateKPaySession = function () {
        return new Promise(function (resolve, reject) {
            kushkiJs.validateSession(function (response) {
                if ("code" in response || "message" in response) {
                    return reject(response);
                }
                resolve(response);
            });
        });
    };
    var requestSubscriptionCardAsyncToken = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestSubscriptionCardAsyncToken(request, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var requestKpayOtpValidation = function (code) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestVerifyAuth({ code: code }, function (response) {
                if ("code" in response || "message" in response)
                    return reject(response);
                resolve(response);
            });
        });
    };
    var deletePaymentMethod = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.deletePaymentMethod(__assign({}, request), function (response) {
                if (!!response) {
                    resolve(!!response);
                }
                if (get(response, "message") !== "ok") {
                    return reject(response);
                }
            });
        });
    };
    var requestInitAuth = function (request) {
        return new Promise(function (resolve, reject) {
            kushkiJs.requestInitAuth(request, function (response) {
                if (!("result" in response))
                    return reject(response);
                resolve(response);
            });
        });
    };
    var value = {
        deletePaymentMethod: deletePaymentMethod,
        requestBankList: requestBankList,
        requestBin: requestBin,
        requestBrandsLogos: requestBrandsLogos,
        requestCardAsyncToken: requestCardAsyncToken,
        requestCardSubscriptionToken: requestCardSubscriptionToken,
        requestCardToken: requestCardToken,
        requestCashToken: requestCashToken,
        requestDeferred: requestDeferred,
        requestInitAuth: requestInitAuth,
        requestKpayOtpValidation: requestKpayOtpValidation,
        requestSavedPaymentMethods: requestSavedPaymentMethods,
        requestSecureServiceValidation: requestSecureServiceValidation,
        requestSubscriptionCardAsyncToken: requestSubscriptionCardAsyncToken,
        requestTransferSubscriptionBankList: requestTransferSubscriptionBankList,
        requestTransferSubscriptionToken: requestTransferSubscriptionToken,
        requestTransferToken: requestTransferToken,
        requestValidateKPaySession: requestValidateKPaySession,
        request3DS: request3DS,
    };
    return (React.createElement(KushkiJsContext.Provider, { value: value }, children));
};
export var useKushkiJsContext = function () {
    return useContext(KushkiJsContext);
};
